import { avTechConfig } from './skillsConfig/avTech'

const Categories = {
  creative: 'creative',
  performance: 'performance',
  knowledge: 'knowledge',
  audioProd: 'audio-prod',
  mediaProd: 'media-prod'
}

const Skills = {
  photographer: 'photographer',
  videographer: 'videographer',
  dj: 'dj',
  musician: 'musician',
  band: 'band',
  makeupArtist: 'makeupArtist',
  dancer: 'dancer',
  miscellaneous: 'miscellaneous',
  technicalAssistant: 'technicalAssistant',
  producer: 'producer',
  icebreaker: 'icebreaker',
  keynoteSpeaker: 'keynoteSpeaker',
  graphicDesigner: 'graphicDesigner',
  avTech: 'avTech'
}
export { Categories, Skills }
